export default __webpack_public_path__ + "static/media/HouseTwo.fbe1db62.jpg";